/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { productSummaryAPI } from '../../../api/Api';
import DokanCard from '../../../components/card/DokanCard';
import DokanList from '../../../components/List/DokanList';
import { fetchData } from '../../../api/GET/fetchData';
import { productsOverview } from '../../../api/ENDPOINTS/overview';
import { fetchProductsSummary } from '../../../redux/products/productsActions';

const ProductsHighlights = () => {
    const { productsSummary } = useSelector((state) => state.products);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchProductsSummary());
    }, [dispatch]);
    return (
        <DokanCard
            cardTitle="Products"
            hasTitle
            hasButton
            buttonText="+ Add New Product"
            buttonLink="/products/create"
            disableMargin
            hasTextColor
            customTextColor="text-orange"
        >
            <div className="text-sm text-primary font-medium">
                <DokanList label="Total" value={productsSummary?.total} hasBorder isFeatured />
                <DokanList label="Live" value={productsSummary?.publish} hasBorder />
                <DokanList
                    label="Offline"
                    value={productsSummary ? productsSummary.total - productsSummary.publish : ''}
                    hasBorder
                />
                <DokanList label="Processing" value="0" hasBorder />
                <DokanList label="Pending Review" value={productsSummary?.pending} hasBorder />
                {/* <DokanList label="Warranty Request" value="0" hasBorder />
                <DokanList label="Refund Request" value="0" hasBorder />
                <DokanList label="Low in Stock" color="text-yellow" value="0" hasBorder />
                <DokanList label="Out of Stock" color="text-red" value="0" hasBorder /> */}
            </div>
        </DokanCard>
    );
};

export default ProductsHighlights;
